import { ROUTE_NAMES } from '@atlassian/jira-common-constants/src/spa-routes';
import type { Route } from '@atlassian/jira-router';

export const isInEligibleRoute = (route: Route) => {
	const allowedRoutes: String[] = [
		ROUTE_NAMES.PROJECT_SETTINGS_SERVICEDESK_REQUEST_TYPES,
		ROUTE_NAMES.PROJECT_SETTINGS_SERVICEDESK_REQUEST_TYPES_FIELDS,
		ROUTE_NAMES.PROJECT_SETTINGS_SERVICEDESK_ITSM_REQUEST_TYPES,
		ROUTE_NAMES.PROJECT_SETTINGS_SERVICEDESK_ITSM_REQUEST_TYPES_FIELDS,
		ROUTE_NAMES.PROJECT_SETTINGS_SERVICEDESK_UNASSIGNED_REQUEST_TYPES,
		ROUTE_NAMES.PROJECT_SETTINGS_SERVICEDESK_UNASSIGNED_REQUEST_TYPES_FIELDS,
	];

	return allowedRoutes.includes(route.name);
};

export const DEFAULT_PROJECT_CREATION_START_DATE = '2024-01-08T00:00:00.000000Z';

export const isNewProject = (
	experimentProjectCreationStartDate: Date,
	projectCreatedTime?: number,
): boolean =>
	projectCreatedTime
		? new Date(projectCreatedTime).getTime() > experimentProjectCreationStartDate.getTime()
		: false;

const ONE_DAY = 1000 * 60 * 60 * 24;
export const calculateDaysDifference = (startDate: number, endDate: number): number =>
	endDate <= startDate ? 0 : Math.ceil((endDate - startDate) / ONE_DAY);
